export default __webpack_public_path__ + "media/src/features/footer/assets/apple_store-658fd8f8923a054f5f188ba0fdf1e1b9.svg";